/*
                        _oo0oo_
                       o8888888o
                       88" . "88
                       (| -_- |)
                       0\  =  /0
                     ___/`---'\___
                   .' \\|     |// '.
                  / \\|||  :  |||// \
                 / _||||| -:- |||||- \
                |   | \\\  -  /// |   |
                | \_|  ''\---/''  |_/ |
                \  .-\__  '-'  ___/-. /
              ___'. .'  /--.--\  `. .'___
           ."" '<  `.___\_<|>_/___.' >' "".
          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
          \  \ `_.   \_ __\ /__ _/   .-` /  /
      =====`-.____`.___ \_____/___.-`___.-'=====
                        `=---='
      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
            佛祖保佑       永无 BUG
            Buddha bless   No Bug Ever
*/

import { createApp } from 'vue'
import App from './App.vue'
// vue router
import router from './router'
// permission router before each
import '@/permission'
// pinia
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
// tailwind
import './styles/tailwind.scss'
// animate css
import '@/styles/animate.css'
// i18n international language
import I18n from '@/local/i18n'
// Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
// system styles
import './styles/styles.scss'
// fontawesome
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
library.add(fas, far, fab)
dom.watch()
// svg sprite loader
import SvgIcon from '@/components/SvgIcon/index.vue'
const req = require.context('@/icons/svg', false, /.svg$/)
req.keys().map(req)
// button wave effect
import VWave from 'v-wave'
// vue leaflet css
import 'leaflet/dist/leaflet.css'
import '@/styles/leaflet.css' // vue leaflet cluster 
// google map extension
import VueGoogleMaps from 'vue-google-maps-community-fork'
// highcharts
import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts'
import SolidGauge from 'highcharts/modules/solid-gauge'
import hcMore from "highcharts/highcharts-more"
import exportingInit from 'highcharts/modules/exporting'
hcMore(Highcharts)
SolidGauge(Highcharts)
Highcharts.setOptions({
  lang: {
    thousandsSep: ','
  }
})
// Initialize exporting module
exportingInit(Highcharts)
// date picker
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import QrcodeVue from 'qrcode.vue'
// import { createGtag } from 'vue-gtag'
import VueGtag, { trackRouter } from "vue-gtag-next";
// const gtag = createGtag({
//   config: { id: 'G-9MBY2FQVZE' } 
// })
// permission directive
import permission from './directives/permission'

const app = createApp(App)
app
  .use(VueGoogleMaps, {
    load: {
      key: process.env.VUE_APP_GOOGLE_MAP_API_KEY,
      loading: 'async',
      libraries: ['places', 'drawing', 'visualization'],
      v: '3.64' //temporary set to 3.64 as 3.65 drawing manager deprecated
    },
    autobindAllEvents: false, // Add this to enable the events
  })
  .use(router)
  .use(pinia)
  .use(I18n)
  .use(ElementPlus)
  .use(HighchartsVue, { highcharts: Highcharts })
  .use(VWave)
  .use(VueGtag, {
    property: { id: 'G-XXHBV42K64' }
  })
  .component('font-awesome-icon', FontAwesomeIcon)
  .component('svg-icon', SvgIcon)
  .component('VueDatePicker', VueDatePicker)
  .component('qrcode-vue', QrcodeVue)
  .directive('permission', permission)
  .mount('#app')

trackRouter(router)

app.config.globalProperties.permissionsList = []
app.config.globalProperties.$highcharts = Highcharts
export { app }
